module.exports = __webpack_public_path__ + "img/3-5.b9cf37c6.png";